import React, { ChangeEvent, Component } from "react";
import OwButton from "../../../shared/OwButton/OwButton";
import OwCheckbox from "../../../shared/OwCheckbox/OwCheckbox";
import ISupplierModel from "../../../../models/ISupplierModel";
import OwTitle from "../../../shared/OwTitle/OwTitle";

type Props = {
    closeModalFn: () => void;
    startFn: (performNameBasedLookup: boolean, useBillToForShipTo?: boolean) => void;
    supplierModel: ISupplierModel;
};

type State = {
    useBillToForShipTo: boolean;
    performNameBasedLookup: boolean;
};

class QBDVendorSyncModal extends Component<Props, State> {
    readonly state: State = {
        useBillToForShipTo: false,
        performNameBasedLookup: false,
    };

    handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const state: any = {
            [name]: value,
        };

        this.setState(state);
    };

    start = () => {
        this.props.startFn(this.state.performNameBasedLookup, this.state.useBillToForShipTo);

        this.props.closeModalFn();
    };

    render() {
        return (
            <div className="QBDVendorSyncModal p-2">
                <div>
                    <div className={""}>
                        <div className={"d-flex justify-content-between"}>
                            <div>
                                <OwTitle
                                    leftIconName={"fad fa-sync"}
                                    title={"vendor_sync"}
                                    isSupplierVendorOverride={true}
                                    supplierModel={this.props.supplierModel}
                                />
                            </div>
                            <div>
                                <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={this.props.closeModalFn} />
                            </div>
                        </div>
                    </div>

                    <div className={"d-flex flex-column"}>
                        <div className={"mt-3"}>
                            <OwCheckbox
                                name={"useBillToForShipTo"}
                                label={"use_bill_to_for_ship_to"}
                                checked={this.state.useBillToForShipTo}
                                truthyVal={true}
                                falsyVal={false}
                                fn={this.handleChange}
                            />
                        </div>
                        <div className={"mt-3"}>
                            <OwCheckbox
                                name={"performNameBasedLookup"}
                                label={"perform_name_based_lookup"}
                                checked={this.state.performNameBasedLookup}
                                truthyVal={true}
                                falsyVal={false}
                                fn={this.handleChange}
                            />
                        </div>
                        <div className={"mt-3"}>
                            <OwButton title={"start"} fn={this.start} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default QBDVendorSyncModal;
